// relative
import { daluxIntegrationApiSlice } from '../apiSlice';

type DaluxApiKeyRecord = {
  apiKey: string;
  createdAt: string;
  expiresAt?: string | null;
};

type SaveDaluxApiKeyRequest = {
  apiKey: string;
  expiresAt?: string | null;
};

type DaluxAssociationRecord = {
  id: string;
  daluxBuildingId: string;
  energyGroupId: number;
  accountId: number;
};

type CreateDaluxAssociationRequest = {
  daluxBuildingId: string;
  energyGroupId: string | number;
};

type SuccessResponse = {
  success: boolean;
};

export const daluxApiSlice = daluxIntegrationApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDaluxApiKey: builder.query<DaluxApiKeyRecord, void>({
      query: () => '/api-key',
      providesTags: ['DaluxApiKey'],
    }),
    saveDaluxApiKey: builder.mutation<SuccessResponse, SaveDaluxApiKeyRequest>({
      query: ({ apiKey, expiresAt }) => ({
        url: '/api-key',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: { apiKey, expiresAt },
      }),
      invalidatesTags: ['DaluxApiKey'],
    }),
    deleteDaluxApiKey: builder.mutation<SuccessResponse, void>({
      query: () => ({
        url: '/api-key',
        method: 'DELETE',
      }),
      invalidatesTags: ['DaluxApiKey'],
    }),
    getDaluxAssociations: builder.query<DaluxAssociationRecord[], void>({
      query: () => '/associations',
      providesTags: ['DaluxAssociation'],
    }),
    createDaluxAssociation: builder.mutation<
      SuccessResponse,
      CreateDaluxAssociationRequest
    >({
      query: ({ daluxBuildingId, energyGroupId }) => ({
        url: '/associations',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: { daluxBuildingId, energyGroupId },
      }),
      invalidatesTags: ['DaluxAssociation'],
    }),
    deleteDaluxAssociation: builder.mutation<SuccessResponse, string>({
      query: (id) => ({
        url: `/associations/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DaluxAssociation'],
    }),
  }),
});

export const {
  useGetDaluxApiKeyQuery,
  useSaveDaluxApiKeyMutation,
  useDeleteDaluxApiKeyMutation,
  useGetDaluxAssociationsQuery,
  useCreateDaluxAssociationMutation,
  useDeleteDaluxAssociationMutation,
} = daluxApiSlice;
